import { Spin } from "antd";
import type { FC } from "react";
import { useParams } from "react-router";

import { DealerChangeLogItemTable } from "src/app/features/DealerChangeLog/components/tables/DealerChangeLogItemTable";
import { useDealerChangeLogLoadQuery } from "src/app/features/DealerChangeLog/services/server/DealerChangeLogApi";
import type { NoneOwnProps } from "../../../../../core/types";

export const DealerChangeLogItemViewForm: FC<NoneOwnProps> = () => {
    const { id } = useParams();
    const { data, isFetching: loadFormIsInProgress } = useDealerChangeLogLoadQuery({ entityId: id });

    return (
        <Spin spinning={loadFormIsInProgress}>
            <DealerChangeLogItemTable
                datasource={{
                    data: data?.logItems ?? [],
                    isFetching: loadFormIsInProgress,
                    selectedRowKeys: [],
                }}
            />
        </Spin>
    );
};
